import requests from './request';

// 查询商家管理员列表
export const reqBusiness = params => {
    return requests({ url: '/mallorgbusiness/selectMallorgbusiness', method: 'get', params });
};
// 添加商家管理员
export const reqAddBusiness = data => {
    return requests({ url: '/mallorgbusiness/addMallorgbusiness', method: 'post', data });
};
// 获取分店信息
export const reqBranchstore = params => {
    return requests({ url: '/mallbranchstore/getMallbranchstore', method: 'get', params });
};
// 删除商家管理员
export const reqDelBusiness = params => {
    return requests({ url: '/mallorgbusiness/deleteMallorgbusiness', method: 'get', params });
};
// 转让管理员
export const reqTransferManager = data => {
    return requests({ url: '/mallorgbusiness/transfer', method: 'post', data });
};
// 更新商家管理员
export const reqUpdateBusiness = data => {
    return requests({ url: '/mallorgbusiness/updateMallorgbusiness', method: 'post', data });
};